import { borderRadiusToTailwindClasses } from "../borderRadiusConverter";

type FillStyle = "outline" | "elevated" | "filled" | "none";


export const tailwindBasisMap = {
    "basis-[0%]": "0%",
    "basis-[5%]": "5%",
    "basis-[10%]": "10%",
    "basis-[15%]": "15%",
    "basis-[20%]": "20%",
    "basis-[25%]": "25%",
    "basis-[30%]": "30%",
    "basis-[35%]": "35%",
    "basis-[40%]": "40%",
    "basis-[45%]": "45%",
    "basis-[50%]": "50%",
    "basis-[55%]": "55%",
    "basis-[60%]": "60%",
    "basis-[65%]": "65%",
    "basis-[70%]": "70%",
    "basis-[80%]": "80%",
    "basis-[90%]": "90%",
    "basis-[100%]": "100%",
};

export const cardThemeToTailwindClasses = (theme: Record<string, string>) => {
    const tailwindClasses = [
        "overflow-hidden",
        "min-w-full @xl:min-w-[calc(50%-1rem)] @7xl:min-w-0",
        "group",
        "grid",
        "gap-0",
        "rounded-lg",
        "border",
        "overflow-hidden",

        // Orientation-based layout
    ];

    const fillStyle = theme.fillStyle as FillStyle;

    if (fillStyle === "outline") {
        tailwindClasses.push(`border border-[--var(border-color)]`);
    }

    if (fillStyle === "elevated") {
        tailwindClasses.push("shadow-lg");
    }

    if (fillStyle === "filled") {
        tailwindClasses.push("bg-white");
    }

    return [...tailwindClasses, ...borderRadiusToTailwindClasses(theme)].filter(
        Boolean,
    );
};
